import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_auth')({
  async beforeLoad({ context }) {},
  async loader({ context }) {
    await context.getInstance('i18n', '@myn/guest');
    await context.getInstance('i18n', '@myn/mui');
  },
});
